import { render, staticRenderFns } from "./SpecHeader.vue?vue&type=template&id=71a9e49c&scoped=true&"
import script from "./SpecHeader.vue?vue&type=script&lang=js&"
export * from "./SpecHeader.vue?vue&type=script&lang=js&"
import style0 from "./SpecHeader.vue?vue&type=style&index=0&id=71a9e49c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9e49c",
  null
  
)

export default component.exports